export default "__VITE_ASSET__UKVEHQMO__"